import Editor from "@monaco-editor/react";
import axios from "axios";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import {
  FaBars,
  FaChevronDown,
  FaChevronRight,
  FaDownload,
  FaFileAlt,
  FaFileArchive,
  FaFileCode,
  FaFileCsv,
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFileWord,
  FaFolder,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatbotButton from "../../../ChatbotButton/ChatbotButton";
import logo from "../../image/AI-logo.png";
import DocxViewer from "./DocxViewer";
import ListOfForms from "./ListOfForms";
import "./Panel.css";
import PdfViewer from "./PdfViewer";
const eagleqmsBackend =
  process.env.REACT_APP_EAGLE_QMS_BACKEND_URL || "https://api.eagleqms.com";

const programmingLanguages = [
  "js",
  "ts",
  "py",
  "java",
  "cpp",
  "c",
  "html",
  "css",
  "json",
  "jsx",
];

// Forms data from your JSON
const formsData = [
  "abstract form",
  "accommodation checklist form",
  "air condition report form",
  "apppointment rec letter accepted form",
  "audit report form",
  "ballasting deballasting form",
  "baltic form",
  "bearing inspection report form",
  "bridge manning matrix form",
  "bunker barge measurement form",
  "bunker letter of protest form",
  "bunker line hydraulic pressure test form",
  "cadet job description form",
  "candidate pre joining briefing & training form",
  "cargo change of watch bulk form",
  "cargo completion of discharging bulk form",
  "cargo completion of loading bulk form",
  "cargo hatch cover maintenance bulk form",
  "cargo loading discharging plan bulk form",
  "cargo preparations for discharging bulk form",
  "cargo preparations for loading bulk form",
  "cargo shipshore safety checklist bulk form",
  "ce nd eng interview q re need to check by tsi form",
  "certificate of competency form",
  "certificate to operate ship_s lifting plant form",
  "change of cargo watch form",
  "checklist cold weather checklist form",
  "checklist navigation in ice form",
  "chief officer_s development checklist form",
  "company standing order form",
  "compass deviation card form",
  "connecting rods report form",
  "crankshaft deflection report form",
  "crankshaft deflection form",
  "crew appraisal form",
  "crew debriefing report form",
  "crew interview q re form",
  "crew list form",
  "crew monthly wages account ( cash on board) form",
  "crew monthly wages account form",
  "crew safety fam n form",
  "crew training cyber security form",
  "critical items checklist form",
  "cyber physical systems form",
  "cylinder condition report form",
  "cylinder liner report form",
  "daily reading monitoring of tail shaft form",
  "damage report bulk vessels form",
  "damage report general cargo form",
  "defects actions pl form",
  "diving & underwater works permit form",
  "drill evaluation form",
  "drug & alcohol compliance form",
  "drydock assessement form",
  "drydocking planning form",
  "drydocking repairs defect form",
  "ecdis cyber security form",
  "ecdis safety parameter settings form",
  "ecdis voyage safety parameters form",
  "electrical isolation permit form",
  "embark _ disembark pilot form",
  "employment agreement form",
  "enclosed space entry permit form",
  "enerva daily reporting sheet form",
  "engine change of watch form",
  "engine pre arrival form",
  "engine pre departure form",
  "engine ums form",
  "epl, shapoli record book form",
  "event report form",
  "familiarisarion bridge deck officers form",
  "familiarisarion cargo deck officers form",
  "familiarisarion engine engineer officers form",
  "familiarisarion safety immediate form",
  "familiarisarion shipboard equipment form",
  "feedback on the shipyard form",
  "fire portal record form",
  "flag state document report form",
  "food _ catering cl form",
  "form bunker spill",
  "form cargo jettisoning",
  "form collision",
  "form electrical power failure",
  "form emer team communication log",
  "form emergency telepho record",
  "form excessive list",
  "form fire in accomodation",
  "form fire in engine room",
  "form fire on deck",
  "form grounding",
  "form gyro failure",
  "form helicopter operations",
  "form main engine failure",
  "form major flooding",
  "form man ovcerboard",
  "form personal injury posioning",
  "form rescue from enclosed space",
  "form search & rescue",
  "form steering gear failure",
  "fresh water generator form",
  "garbage disposal receipt form",
  "handing over change of command form",
  "handing over report bosun form",
  "handing over report chief cook form",
  "handing over report chief engineer form",
  "handing over report chief officer form",
  "handing over report electrical officer form",
  "handing over report third officer form",
  "hatch covers maintenance form",
  "heavy lift operations form",
  "helicopter operations checklist form",
  "hold cleaning material inventory form",
  "hold cleaning time management sheet form",
  "hot work permit form",
  "hygiene inspection form",
  "internal audit checklist form",
  "interview plan form",
  "investigation report form",
  "landing advice form",
  "letter of indemnity form",
  "lock out tag out log form",
  "lub chem inventory form",
  "maintenance ae form",
  "maintenance me form",
  "man t of change pr l form",
  "management review form",
  "master co interview q re form",
  "master general account (mga) form",
  "master pilot exchange form",
  "master verification checklist form",
  "masters review form",
  "me performance report",
  "medical inventory form",
  "medical report form",
  "medicine log form",
  "megger test form",
  "monthly auxiliary con form",
  "navigation anchoring & anchor watch form",
  "navigation change of watch form",
  "navigation coastal waters form",
  "navigation heavy weather tropical storm form",
  "navigation noon tests & checks form",
  "navigation pre arrival form",
  "navigation pre departure form",
  "navigation restricted visibility form",
  "navigational audit form",
  "nd engineer_s development checklist form",
  "nd officer_s development checklist form",
  "network segregation form",
  "networks (wireless _ wired form",
  "newbuilding report form",
  "on board complaint form",
  "on board familiarisation ecdis deck officers form",
  "on board familiarisation furuno ecdis deck officers form",
  "on board ot systems form",
  "on board training program form",
  "on board training_module matrix_attendance sheet form",
  "on board training_report form",
  "onboard alcohol testing results form",
  "passage plan appraisal form",
  "personal performance feedback self evaluation",
  "pistons report form",
  "pollution prevention compliance form",
  "port log form",
  "pre bunkering plan form",
  "pre departing sy cl form",
  "pre entering sy cl form",
  "privacy note form",
  "qualification sheet form",
  "rd engineer_s development checklist form",
  "rd officer_s development checklist form",
  "receipt for goods or services form",
  "record of engine parameters (engine record book) form",
  "reference check form",
  "refrigerant record form",
  "remote access form",
  "request for medical form",
  "risk assessment blank form",
  "safety testing form",
  "sample & bdn record form",
  "satellite communications form",
  "seafarer application form",
  "seafarer perf app officers _ cadets form",
  "seafarer perf app ratings form",
  "seemp checklist form",
  "seepc meeting minutes form",
  "senior officer_s briefing form",
  "shore staff briefing checklist form",
  "slopchest account form",
  "sludge & bilge discharge form",
  "small craft alongside permit form",
  "squat calculator form",
  "standard display sheet form",
  "statement of rob (lubricants) form",
  "steering gear test form",
  "supplier evaluation form",
  "tail shaft monitoring (tcm notation) record form",
  "tank hold inspection report form",
  "tank report form",
  "th engineer_s development checklist form",
  "under keel clearance form",
  "vessel repatriation plan form",
  "vessel takeover report form",
  "vessel tank measurement form",
  "watch & rest schedule requirements & display form",
  "weekly maintenance report form",
  "weekly ows test form",
  "work aloft n outboard permit form",
];

const Panel = () => {
  const [structure, setStructure] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [expandedFolders, setExpandedFolders] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [showFormsList, setShowFormsList] = useState(false);
  const [expandedListOfForms, setExpandedListOfForms] = useState(false);
  const sidebarRef = useRef(null);
  const folderInputRef = useRef(null);

  const navigate = useNavigate();

  const fileExtension = selectedFile?.name.split(".").pop();
  const isCodeFile = programmingLanguages.includes(fileExtension);

  // Fetch files and folders from the backend
  useEffect(() => {
    fetchFiles();
  }, []);

  // Handle window resize events
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobileView(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "removeSession") {
        const data = JSON.parse(event.newValue);
        const currentSessionId = sessionStorage.getItem("currentToken");
        if (currentSessionId === data.id) {
          sessionStorage.removeItem("currentToken");
          localStorage.removeItem(`chatHistory_${data.id}`);
          navigate("/login");
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  // Handle clicks outside sidebar to close it on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileView &&
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileView, sidebarOpen]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  const displayFile = async (binaryData) => {
    try {
      const byteArray = new Uint8Array(binaryData.buffer);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    } catch (error) {
      console.error("Error displaying file:", error);
      toast.error("Error displaying file");
    }
  };

  const getAxiosMsg = (err, fallback = "Something went wrong") =>
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    fallback;

  const fetchFiles = async () => {
    const promise = axios.get(`${eagleqmsBackend}/api/files/files`);

    toast.promise(promise, {
      pending: "Fetching files...",
      success: "Files loaded",
      error: {
        render({ data }) {
          return getAxiosMsg(data, "Failed to fetch files");
        },
      },
    });

    try {
      const res = await promise;
      console.log("Fetched files from backend:", res.data);
      setStructure(buildStructure(res.data));
    } catch (error) {
      console.error("Failed to fetch files:", error);
    }
  };

  const handleDownload = async () => {
    if (!selectedFile) return;

    try {
      let downloadContent;
      let fileName = selectedFile.name;
      let mimeType;
      let fileBlob;

      if (selectedFile.fileData) {
        const byteArray = new Uint8Array(selectedFile.fileData);

        switch (fileExtension) {
          case "pdf":
            mimeType = "application/pdf";
            break;
          case "docx":
            mimeType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            break;
          case "doc":
            mimeType = "application/msword";
            break;
          case "xlsx":
            mimeType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            break;
          case "xls":
            mimeType = "application/vnd.ms-excel";
            break;
          case "csv":
            mimeType = "text/csv";
            break;
          case "jpg":
          case "jpeg":
            mimeType = "image/jpeg";
            break;
          case "png":
            mimeType = "image/png";
            break;
          default:
            mimeType = "application/octet-stream";
        }

        fileBlob = new Blob([byteArray], { type: mimeType });
      } else {
        switch (fileExtension) {
          case "html":
            mimeType = "text/html";
            break;
          case "css":
            mimeType = "text/css";
            break;
          case "js":
            mimeType = "application/javascript";
            break;
          case "json":
            mimeType = "application/json";
            break;
          case "csv":
            mimeType = "text/csv";
            break;
          default:
            mimeType = "text/plain";
        }

        downloadContent = selectedFile.content;
        fileBlob = new Blob([downloadContent], { type: mimeType });
      }

      const url = URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(url);
      document.body.removeChild(link);

      toast.success(`Downloading ${fileName}`, {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download file");
    }
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();

    switch (extension) {
      case "jpg":
      case "png":
      case "gif":
        return <FaFileImage className="file-icon image" />;
      case "pdf":
        return <FaFilePdf className="file-icon pdf" />;
      case "doc":
      case "docx":
        return <FaFileWord className="file-icon word" />;
      case "xls":
      case "xlsx":
        return <FaFileExcel className="file-icon excel" />;
      case "csv":
        return <FaFileCsv className="file-icon csv" />;
      case "zip":
      case "rar":
        return <FaFileArchive className="file-icon archive" />;
      case "js":
      case "html":
      case "css":
      case "jsx":
        return <FaFileCode className="file-icon code" />;
      default:
        return <FaFileAlt className="file-icon default" />;
    }
  };

  const buildStructure = (files) => {
    const root = [];

    files.forEach((file) => {
      let currentLevel = root;

      // Traverse through the path to build folder structure
      file.path.forEach((folderName) => {
        let existingFolder = currentLevel.find(
          (item) => item.name === folderName && item.type === "folder"
        );

        if (!existingFolder) {
          existingFolder = {
            name: folderName,
            type: "folder",
            children: [],
          };
          currentLevel.push(existingFolder);
        }

        currentLevel = existingFolder.children;
      });

      // Add the current item based on its type
      if (file.type === "folder") {
        // Check if folder doesn't already exist at current level
        const exists = currentLevel.some(
          (item) => item.name === file.name && item.type === "folder"
        );
        if (!exists) {
          currentLevel.push({
            _id: file._id,
            name: file.name,
            type: "folder",
            children: [],
          });
        }
      } else {
        // Treat everything else as a file (including PDFs, DOCX, etc.)
        currentLevel.push({
          _id: file._id,
          name: file.name,
          type: file.type || "file", // Use original type or default to "file"
          content: file.content,
        });
      }
    });

    return root;
  };

  const saveFileOrFolder = async (item) => {
    try {
      await axios.post(`${eagleqmsBackend}/api/files/save`, item);
      toast.success(
        `${item.type === "folder" ? "Folder" : "File"} created successfully!`,
        {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
      fetchFiles();
    } catch (error) {
      console.error("Failed to save file/folder:", error);
      toast.error(
        `Failed to create ${item.type === "folder" ? "folder" : "file"}`
      );
    }
  };

  const renameItem = async (oldPath) => {
    const newName = prompt("Enter new name:");
    if (!newName || newName.trim() === "") return;

    try {
      console.log("Renaming file. Old path:", oldPath, "New name:", newName);

      const response = await axios.put(`${eagleqmsBackend}/api/files/rename`, {
        oldPath,
        newName,
      });

      console.log("Rename response:", response.data);

      if (response.status === 200) {
        toast.success("Item renamed successfully!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        fetchFiles();
      }
    } catch (error) {
      console.error("Failed to rename file:", error);

      let errorMessage = "An unknown error occurred";

      if (error.response) {
        errorMessage = error.response.data.error || "Server returned an error";
        console.error("Server error details:", error.response.data);
      } else if (error.request) {
        errorMessage = "No response received from server";
      } else {
        errorMessage = error.message;
      }

      toast.error("Failed to rename: " + errorMessage);
    }
  };

  const checkForDuplicates = (structure, path, names) => {
    let currentLevel = structure;

    // Navigate to the target directory
    for (const folderName of path) {
      const folder = currentLevel.find(
        (item) => item.name === folderName && item.type === "folder"
      );
      if (folder) {
        currentLevel = folder.children || [];
      } else {
        // Path doesn't exist, so no duplicates possible
        return [];
      }
    }

    // Check for existing names in current directory (case-insensitive)
    const duplicates = names.filter((name) => {
      return currentLevel.some(
        (item) => item.name.toLowerCase() === name.toLowerCase()
      );
    });

    return duplicates;
  };

  // Helper function to get user-friendly path display
  const getPathDisplay = (path) => {
    if (path.length === 0) return "Root";
    return `/${path.join("/")}`;
  };

  // Helper function to validate file/folder names for CA system
  const validateCAFileName = (name) => {
    const trimmed = name.trim();

    if (!trimmed) {
      return { valid: false, message: "Name cannot be empty" };
    }

    // Check for invalid characters (optional - customize based on your needs)
    const invalidChars = /[<>:"|?*]/;
    if (invalidChars.test(trimmed)) {
      return { valid: false, message: "Name contains invalid characters" };
    }

    return { valid: true, name: trimmed };
  };

  // Helper function to check if this is a common CA folder structure
  const isCommonCAFolder = (folderName) => {
    const commonFolders = [
      "forms",
      "appendices",
      "notes",
      "practice-questions",
      "case-studies",
      "reference-materials",
      "theory",
      "practical",
      "filled-forms",
      "blank-forms",
      "solutions",
      "examples",
    ];
    return commonFolders.includes(folderName.toLowerCase());
  };

  const createFolder = (path = []) => {
    const name = prompt("Enter folder name:");
    if (!name) return;

    // Validate the folder name
    const validation = validateCAFileName(name);
    if (!validation.valid) {
      toast.error(validation.message, {
        position: "top-center",
        autoClose: 4000,
        theme: "colored",
      });
      return;
    }

    const trimmedName = validation.name;

    // Check for duplicates ONLY in the current directory
    const duplicates = checkForDuplicates(structure, path, [trimmedName]);

    if (duplicates.length > 0) {
      const pathDisplay = getPathDisplay(path);
      const isCommon = isCommonCAFolder(trimmedName);

      toast.error(
        `Cannot create folder: "${trimmedName}" already exists in ${pathDisplay}${
          isCommon
            ? '\n(Common CA folders like "forms", "appendices" are allowed in different chapters)'
            : ""
        }`,
        {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
      return;
    }

    const newFolder = { name: trimmedName, type: "folder", path, children: [] };
    saveFileOrFolder(newFolder);
  };

  const createFile = (path = []) => {
    const name = prompt("Enter file name:");
    if (!name) return;

    // Validate the file name
    const validation = validateCAFileName(name);
    if (!validation.valid) {
      toast.error(validation.message, {
        position: "top-center",
        autoClose: 4000,
        theme: "colored",
      });
      return;
    }

    const trimmedName = validation.name;

    // Check for duplicates ONLY in the current directory
    const duplicates = checkForDuplicates(structure, path, [trimmedName]);

    if (duplicates.length > 0) {
      const pathDisplay = getPathDisplay(path);
      toast.error(
        `Cannot create file: "${trimmedName}" already exists in ${pathDisplay}`,
        {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
      return;
    }

    const content = prompt("Enter file content:");
    const newFile = { name: trimmedName, type: "file", path, content };

    saveFileOrFolder(newFile);
  };

  const uploadFiles = async (event, path = []) => {
    const files = event.target.files;
    if (!files.length) return;

    // Extract file names
    const fileNames = Array.from(files).map((file) => file.name);

    // Check for duplicates ONLY in the exact same directory
    const duplicates = checkForDuplicates(structure, path, fileNames);

    if (duplicates.length > 0) {
      const duplicateList = duplicates.join(", ");
      const pathDisplay = getPathDisplay(path);

      toast.error(
        `Cannot upload: ${
          duplicates.length > 1 ? "Files" : "File"
        } "${duplicateList}" already exist${
          duplicates.length > 1 ? "" : "s"
        } in ${pathDisplay}`,
        {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );

      // Reset the file input
      event.target.value = "";
      return;
    }

    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    formData.append("path", JSON.stringify(path));

    try {
      const response = await axios.post(
        `${eagleqmsBackend}/api/files/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success(
        `${files.length > 1 ? "Files" : "File"} uploaded successfully!`,
        {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
      fetchFiles();
    } catch (error) {
      console.error("Failed to upload files:", error);
      toast.error("Failed to upload files");
    } finally {
      // Reset the file input
      event.target.value = "";
    }
  };

  // Enhanced uploadFolder function with duplicate checking
  const uploadFolder = async (event, path = []) => {
    const files = event.target.files;
    if (!files.length) return;

    const formData = new FormData();
    const relativePaths = [];

    // Get the root folder name from the first file
    const firstFile = files[0];
    const rootFolderName = firstFile?.webkitRelativePath?.split("/")[0];

    if (!rootFolderName) {
      toast.error("Unable to determine folder name");
      if (folderInputRef.current) {
        folderInputRef.current.value = "";
      }
      return;
    }

    // Check if folder already exists in the EXACT same target directory
    const duplicates = checkForDuplicates(structure, path, [rootFolderName]);

    if (duplicates.length > 0) {
      const pathDisplay = getPathDisplay(path);

      toast.error(
        `Cannot upload folder: "${rootFolderName}" already exists in ${pathDisplay}`,
        {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );

      // Reset the input
      if (folderInputRef.current) {
        folderInputRef.current.value = "";
      }
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const relativePath = file.webkitRelativePath || file.name;

      formData.append("files", file);
      relativePaths.push(relativePath);
    }

    formData.append("basePath", JSON.stringify(path));

    relativePaths.forEach((relativePath, index) => {
      formData.append(`relativePaths[${index}]`, relativePath);
    });

    try {
      await axios.post(`${eagleqmsBackend}/api/files/upload-folder`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success(`Folder '${rootFolderName}' uploaded successfully!`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      fetchFiles();
    } catch (error) {
      console.error("Failed to upload folder:", error);
      toast.error("Failed to upload folder");
    } finally {
      if (folderInputRef.current) {
        folderInputRef.current.value = "";
      }
    }
  };

  const openFile = async (file) => {
    const extension = file.name.split(".").pop().toLowerCase();

    try {
      setShowFormsList(false);

      if (isMobileView && sidebarOpen) {
        setSidebarOpen(false);
      }

      if (file.type === "file" && file.content) {
        setSelectedFile(file);
        return;
      }

      const fileId = file._id;
      let updatedFile = { ...file };

      // Simplified endpoint mapping - removed excel, csv, and doc endpoints
      const endpointMap = {
        pdf: `/api/files/pdf/${fileId}`,
        docx: `/api/files/docx/${fileId}`,
        txt: `/api/files/txt/${fileId}`,
      };

      const endpoint = endpointMap[extension];

      if (!endpoint) {
        try {
          const response = await axios.get(
            `${eagleqmsBackend}/api/files/txt/${fileId}`
          );
          if (response.data?.content) {
            updatedFile.content = response.data.content;
          }
        } catch (error) {
          toast.error("Unsupported file type");
          return;
        }
      } else {
        const response = await axios.get(`${eagleqmsBackend}${endpoint}`);

        if (extension === "txt" && response.data?.content) {
          updatedFile.content = response.data.content;
        } else if (response.data?.fileData) {
          updatedFile.fileData = response.data.fileData.data;
        }
      }

      setSelectedFile(updatedFile);
    } catch (error) {
      console.error("Error opening file:", error);
      toast.error(
        `Error opening ${extension.toUpperCase()} file: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const toggleFolder = (folderName) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderName]: !prev[folderName],
    }));
  };

  const toggleListOfForms = () => {
    setExpandedListOfForms((prev) => !prev);
  };

  const handleAvailableFormsClick = () => {
    // Create a virtual file object for "available forms"
    const availableFormsFile = {
      name: "available forms",
      type: "forms-list",
      content: "This contains all available forms for the document system.",
    };

    setSelectedFile(availableFormsFile);
    setShowFormsList(true);

    if (isMobileView && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  const handleFormClick = (formName) => {
    setShowFormsList(true);
    setSelectedFile(null);
  };

  const filterFiles = (items) => {
    if (!searchTerm) return items;

    return items
      .map((item) => {
        if (item.type === "folder") {
          const filteredChildren = filterFiles(item.children || []);
          if (
            filteredChildren.length > 0 ||
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return { ...item, children: filteredChildren };
          }
          return null;
        }
        return item.name.toLowerCase().includes(searchTerm.toLowerCase())
          ? item
          : null;
      })
      .filter(Boolean);
  };

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const renderStructure = (items, parentPath = []) => {
    if (!items || items.length === 0) {
      return <p>No files or folders found.</p>;
    }

    return (
      <ul>
        {[...items]
          .sort((a, b) => {
            if (a.name === "first") return -1;
            if (b.name === "first") return 1;

            if (a.type === "folder" && b.type === "file") return -1;
            if (a.type === "file" && b.type === "folder") return 1;
          })
          .map((item) => (
            <li key={item.name}>
              {item.type === "folder" ? (
                <div className="folder-container">
                  <span
                    className="folder-title"
                    onClick={() => toggleFolder(item.name)}
                  >
                    {expandedFolders[item.name] ? (
                      <FaChevronDown />
                    ) : (
                      <FaChevronRight />
                    )}
                    <FaFolder className="folder-icon" /> {item.name}
                  </span>
                  <div className="action-buttons">
                    <button
                      onClick={() => createFolder([...parentPath, item.name])}
                      className="dms"
                    >
                      ➕ Folder
                    </button>
                    <button
                      onClick={() => createFile([...parentPath, item.name])}
                      className="dms"
                    >
                      📄 File
                    </button>
                    <label className="upload-button dms">
                      📤 Upload File
                      <input
                        type="file"
                        multiple
                        onChange={(e) =>
                          uploadFiles(e, [...parentPath, item.name])
                        }
                        hidden
                      />
                    </label>
                  </div>
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{
                      height: expandedFolders[item.name] ? "auto" : 0,
                      opacity: expandedFolders[item.name] ? 1 : 0,
                    }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="folder-contents"
                  >
                    {expandedFolders[item.name] &&
                      renderStructure(item.children || [], [
                        ...parentPath,
                        item.name,
                      ])}
                  </motion.div>
                </div>
              ) : (
                <div className="fileNameGroup">
                  <span className="file-title" onClick={() => openFile(item)}>
                    {getFileIcon(item.name)} {item.name}
                  </span>
                </div>
              )}
            </li>
          ))}
      </ul>
    );
  };

  return (
    <div className={`header-container ${isMobileView ? "mobile-view" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      {isMobileView && (
        <>
          <button className="mobile-menu-toggle dms" onClick={toggleSidebar}>
            {sidebarOpen ? <FaTimes /> : <FaBars />}
          </button>
          <div
            className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
            onClick={closeSidebar}
          ></div>
        </>
      )}

      <div
        ref={sidebarRef}
        className={`panel-container ${isMobileView ? "mobile" : ""} ${
          sidebarOpen ? "open" : ""
        }`}
      >
        <div className="logout-button-wrapper">
          <button className="button-45" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <div className="custom-sidebar-logo">
          <img src={logo} alt="Eagle Document System Logo" />
        </div>
        <h2>Document System</h2>

        <div className="groupSearchCreateFolder">
          <button onClick={() => createFolder()} className="dms">
            ➕ Create Folder
          </button>

          <div className="search-bar">
            <FaSearch />
            <input
              type="text"
              placeholder="Search files..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* List Of Forms Folder */}
        <div className="formlist">
          <div className="folder-container">
            <span className="folder-title" onClick={toggleListOfForms}>
              {expandedListOfForms ? <FaChevronDown /> : <FaChevronRight />}
              <FaFolder className="folder-icon" /> List Of Forms
            </span>

            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{
                height: expandedListOfForms ? "auto" : 0,
                opacity: expandedListOfForms ? 1 : 0,
              }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="folder-contents"
            >
              {expandedListOfForms && (
                <ul>
                  <li>
                    <div className="fileNameGroup">
                      <span
                        className="file-title"
                        onClick={handleAvailableFormsClick}
                      >
                        <FaFileAlt className="file-icon default" /> available
                        forms
                      </span>
                    </div>
                  </li>
                </ul>
              )}
            </motion.div>
          </div>
        </div>

        {/* Regular file structure */}
        {renderStructure(filterFiles(structure))}
      </div>

      <div className={`file-preview ${isMobileView ? "mobile" : ""}`}>
        {showFormsList ? (
          <ListOfForms formsData={formsData} />
        ) : selectedFile ? (
          <div className="file-item">
            <h3>{selectedFile.name}</h3>

            {/* PDF Viewer */}
            {fileExtension === "pdf" && selectedFile.fileData ? (
              <PdfViewer
                key={`pdf-${
                  selectedFile._id || selectedFile.name
                }-${Date.now()}`}
                fileData={selectedFile.fileData}
              />
            ) : fileExtension === "pdf" ? (
              <div className="loading-pdf">Unable to display PDF content</div>
            ) : null}
            {/* DOCX Viewer */}

            {fileExtension === "docx" && selectedFile.fileData ? (
              <div className="docx-viewer">
                <DocxViewer fileData={selectedFile.fileData} />
              </div>
            ) : fileExtension === "docx" && selectedFile.type === "file" ? (
              <pre className="file-content">{selectedFile.content}</pre>
            ) : fileExtension === "docx" ? (
              <div className="loading-docx">
                Unable to display document content
              </div>
            ) : null}

            {fileExtension === "doc" && selectedFile.fileData ? (
              <div className="doc-viewer">
                <DocxViewer fileData={selectedFile.fileData} />
              </div>
            ) : fileExtension === "doc" && selectedFile.type === "file" ? (
              <pre className="file-content">{selectedFile.content}</pre>
            ) : fileExtension === "doc" ? (
              <div className="loading-doc">
                Unable to display document content
              </div>
            ) : null}

            {/* Text Files */}
            {fileExtension === "txt" ? (
              <pre className="file-content">{selectedFile.content}</pre>
            ) : null}

            {/* Code Files */}
            {isCodeFile &&
            !["pdf", "docx", "doc", "txt", "csv", "xls", "xlsx"].includes(
              fileExtension
            ) ? (
              <Editor
                height="400px"
                defaultLanguage={fileExtension}
                value={selectedFile.content || ""}
                theme="vs-dark"
                options={{
                  fontSize: 14,
                  minimap: { enabled: false },
                  lineNumbers: "on",
                  scrollBeyondLastLine: false,
                  readOnly: true,
                }}
              />
            ) : null}

            {/* Other Files */}
            {!["pdf", "docx", "doc", "txt", "csv", "xls", "xlsx"].includes(
              fileExtension
            ) &&
            !isCodeFile &&
            selectedFile.type === "file" ? (
              <pre className="file-content">{selectedFile.content}</pre>
            ) : null}

            <div className="button-group">
              <button onClick={handleDownload} className="download-button dms">
                <FaDownload /> Download
              </button>
              <button onClick={() => setSelectedFile(null)} className="dms">
                Close
              </button>
            </div>
          </div>
        ) : (
          <div className="empty-preview">
            <h2>Welcome to your Document System</h2>
            <p>
              Manage your files efficiently with our advanced file management
              system. You can create folders, upload files, rename, delete, and
              organize them easily.
            </p>
          </div>
        )}
      </div>
      {/* Chatbot Button */}
      <div className="chatbot-button-wrapper">
        <ChatbotButton />
      </div>
    </div>
  );
};
export default Panel;
